import { createContext, useState, useEffect } from "react";
import config from "../config";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Retrieve token from localStorage
        const token = localStorage.getItem("access_token");

        if (token) {
            fetch(`${config.REACT_APP_API_URL}/auth/users/me`, {
                headers: { Authorization: token }, // Send token in Authorization header
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.email) {
                        setUser(data);
                    }
                })
                .catch(() => setUser(null))
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, []);

    const logout = () => {
        localStorage.removeItem("access_token"); // Remove token from localStorage
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, setUser, loading, logout }}>
            {children}
        </AuthContext.Provider>
    );
};